import styled from '@emotion/styled'
import React, { useEffect, useState,useContext } from 'react'
import {FaGlobeAmericas as TopIcon} from 'react-icons/fa';
import { Button, FilterDropDown,option1 } from '../../../../ui-components';
import {BsChevronLeft as LeftIcon,BsChevronRight as RightIcon} from 'react-icons/bs';
import styles from '../../Applicants/css/display-applicant.module.css';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';
import { apiRequest } from '../../../../api';
import { NotificationContext } from '../../../../providers/notification';
import { useSettingModal } from '../../../../hooks/Context';
import Checkbox from '@mui/material/Checkbox';
import { AxiosError } from 'axios';
import BatchIdGenTable from './BatchIdGenTable';
import { CircularProgress } from '@mui/material';
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData} from '../../../../hooks/FetchData';
import { ExNyRoute } from '../../../../utils/allRouteId';

let end = 0;


interface PendingAdmissionProps {
  ApplicantId: string;
  FullName: string;
  EmailAddress: string;
  RouteName: string;
  RouteId: number;
  HasInducted: boolean;
}

const BatchIdGen = () => {
    const [select_all,set_select_all] = useState<boolean>(false);
    const [selected_idgen,set_selected_idgen]= useState<any>([]);
    const [active_data,set_active_data] = useState<PendingAdmissionProps[]>([]);
    const [active_route,setActiveRoute] = useState<any>(ExNyRoute);
    const [message,set_message] = useState<any>('');
    const {showNotification} = useContext(NotificationContext);
    const [searchData, setSearchData] = useState('');
    const {setShowModal} = useSettingModal();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage ] = useState('');
    


    const {isLoading: allRouteIsLoading,data: allRoutedata} = FetchAllRoutes();

    const reOrderedAllRoutes = allRoutedata ? reOrderFetchedData((allRoutedata as RouteResponse )?.Data) : []

    const allRoutes = allRouteIsLoading ? [] : reOrderedAllRoutes.map((item) => {return {name: item?.RouteName, val: item?.RouteId}})


    const [loading,set_loading] = useState<boolean>(false);
    const [data,set_data] = useState<PendingAdmissionProps[]>([]);
    const applicationOpt = [
        {name:'Training',val:'1'},
        {name:"Induction",val:'2'},
    ];

    const submitBatchIdGen= (e:any) =>{
        e.preventDefault();
        const routeId = active_route.val;
        const activity = "IdGen";
        if(selected_idgen.length > 0){
            set_loading(true);
            let obj:any = {
                RouteId:routeId,
                ApplicantDtos:[]

            };
            obj.ApplicantDtos = selected_idgen.map((e_data:any)=> ({ApplicantId:`${e_data.ApplicantId}`}))
            obj = JSON.stringify(obj);
            apiRequest(`api/Activity/GenerateMembership`,"POST",obj)
            .then(data => {
                set_loading(false);
                setShowModal(false);
                set_select_all(false);
                showNotification({
                    message: 'Membership Id is Successfully Generated!',
                    type: 'success'
                  })
            })
            .catch(error=>{
                set_loading(false);
                setShowModal(false);
                showNotification({
                    message: error?.response?.data?.Message || error.Message,
                    type: 'error'
                  })
            })
        }
    }

    useEffect(()=>{
        if(active_route && active_route.val){

            setIsLoading(true);
            apiRequest(`api/Activity/GetApplicantPendingAdmission?routeId=${active_route.val || 1}&activity=Induction`,'GET').then((data:any) =>{
                set_active_data(data.Data);
                setIsError(false);
                setIsLoading(false);
            })
            .catch((error:AxiosError) =>{
                setIsError((true))
                setErrorMessage(error?.message)
                set_active_data([])
                setIsLoading(false);
            })

        }
    },[active_route])

    const filteredData = active_data?.filter(x => (
        Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
      ));
    
      

  return (
    <Wrapper>
        <div className='first-div'>
            <span>
                <TopIcon />
            </span>
        </div>
        <div className='filter-div'>
            <div>Generate Membership Id</div>
            <div>
            <label className={styles.searchForm} ><span className={styles.sI}><SearchIcon/></span><input type="text" placeholder='Search' value={searchData} onChange={e => setSearchData(e.target.value) }/><button className={styles.rBtn} type="submit"><ReloadIcon/></button></label>
                <FilterDropDown bg="#11643C" color="#fff" text="Membership Routes" options={allRoutes} onChange={setActiveRoute} replace='true' />
                <FilterDropDown text="Application Period" options={applicationOpt} />
                <SelectBtn >
                    <span>Select</span>
                    <Checkbox checked={select_all} onChange={()=>set_select_all(!select_all)} sx={{marginBlockEnd: '3px'}} />
                </SelectBtn>
            </div>
        </div>

        {
            isLoading ? (
                <CircularProgress 
                  sx={{
                    fontSize: '1rem',
                    marginInline: 'auto',
                    display: 'block',
                    marginBlock: '2rem'
                  }}
                />
            ) : isError ? (
                <StyledError>{errorMessage}</StyledError>
            ) : filteredData && filteredData?.length > 0 ?
            <BatchIdGenTable data = {searchData.length > 0 ? filteredData : active_data} selectAll={select_all} selected_idgen = {selected_idgen} set_selected_idgen = {set_selected_idgen} />
            : <NoResult>No Results</NoResult>
        }
        <div>
            <MessageForm onSubmit={submitBatchIdGen}>
                {/* <label>
                    <span>Message</span>
                    <textarea value={message} onChange={(e:any)=>set_message(e.target.value)} rows={6} placeholder='Enter IdGenMessage Here'></textarea>
                </label> */}
                <div>
                    <Button bg="#5BC065" border="#5BC065" style={{padding:'13px 20px'}}>
                        {!loading?'Generate Id':'Loading...'}
                    </Button>
                </div>
            </MessageForm>
        </div>
        
    </Wrapper>
  )
}

export default BatchIdGen;

const NoResult = styled('div')`
  margin-block-start: 10px;
  margin-block-end: 200px;
`

const SelectBtn = styled.label`
    margin-left:auto;
    width:fit-content;
    align-items: center;
    padding:10px 15px;
    display:flex;
    gap:10px;
    cursor:pointer;
`

const Wrapper = styled.div`
    width:calc(100vw - 140px);
    padding:20px;
    border-radius: 10px;
    background-color:var(--white-color);
    display: grid;
    grid-template-columns: 1fr;
    & > .first-div{
        display:flex;
    }
    & > .first-div > span{
        width:50px;
        height:50px;
        display: flex;
        justify-content:center;
        align-items:center;
        background-color:#FFF4DE;
        color:#FEB930;
    }
    & > .filter-div{
        display:flex;
        flex-direction:column;
        gap:10px;
        margin-top:20px;
    }
    & > .filter-div > div:first-of-type{
        font-size:18px;
        font-weight:bold;
    }
    & > .filter-div > div:nth-of-type(2){
        display:flex;
        gap:15px;
    }
    & > .table-div{
        display:flex;
        flex-direction:column;
        gap:5px;
        margin-top:10px;
    }
    & > .table-div > div{
        width:100%;
    }
    & .t-head{
        display:grid;
        grid-template-columns:50px repeat(4,1fr);
        background-color:#E0FAEE;
        padding:15px 10px;
    }

    
`

const Tbody = styled.div`
    display: flex;
    gap:8px;
    flex-direction: column;
    border-top:2px solid #E2E4E9;
    border-bottom:2px solid #E2E4E9;
    min-height: 250px;

    & > div{
        border-left:2px solid #fff;
        display:grid;
        grid-template-columns:50px repeat(4,1fr);
        padding:10px 7px;
    }
    & > div:hover{
        border-left-color:#293856;
    }

    
`
const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`


const EachRow = (props:any)=>{
    const data = props.eachRow || null;
    const [temp_select,set_temp_select] = useState<boolean>(false);
    const select_all = props.selectAll;
    const {selected_idgen,set_selected_idgen} = props.idgen;

    const handleTempSelect = () =>{
        const id = data.ApplicantId;
        let check = selected_idgen.find(function(eidgen:any){
            return eidgen.ApplicantId == id; 
        })
        if(check){
            set_selected_idgen(
                selected_idgen.filter((eidgen:any)=> eidgen.ApplicantId != id)
            )
            set_temp_select(false);
        }else{
            set_selected_idgen(
                [...selected_idgen,data]
            )
            set_temp_select(true);
        }
    }


    useEffect(()=>{
        const id = data.ApplicantId;
        if(select_all){
            set_temp_select(true);
            let check = selected_idgen.find(function(eidgen:any){
                return eidgen.ApplicantId == id; 
            })
            if(check){
                set_temp_select(false);
            }else{
                set_selected_idgen(
                    [...selected_idgen,data]
                )
                set_temp_select(true);
            }
        }else{
            set_selected_idgen(
                selected_idgen.filter((eidgen:any)=> eidgen.ApplicantId != id)
            )
            set_temp_select(false);
        }
    },[select_all])

   




    return(
        <>
        { data? <div >
            <Checkbox checked={temp_select} onChange={()=>handleTempSelect()} />
            <span >{data.ApplicantId?data.ApplicantId.slice(0,15):''}...</span>
            <span>{data.FullName}</span>
            <span>{data.EmailAddress}</span>
            <span>{data.RouteName}</span>
        </div>:
        ''
        }
        </>
    )
}

const PageDiv = styled.div`
    padding:10px 30px;
    display: flex;
    justify-content:flex-end;
    align-items:center;
    position:relative;
    & > div{
        position:relative;
        display: flex;
        align-items: center;
    }
    & > div > div{
        display:flex;
        gap:5px;
        flex-wrap:wrap;
        width:fit-content;
        align-items:center;
    }
    & > div > span{
        position: absolute;
        top:0px;
        cursor:pointer;
    }
    & > div > span:first-of-type{
        left:-30px;
    }
    & > div > span:last-of-type{
        right:-30px;
    }
    & > div > div > span{
        width:fit-content;
        padding:3px 5px;
        display:flex;
        justify-content:center;
        align-items:center;
        height:20px;
        border-radius:3px;
        cursor:pointer;
    }
    & > div > div > span.active{
        color:#fff;
        background-color: #11643C;
    }

`
const Pagination = (props:any) =>{
    const no_per_page = 5;
    const data = props.data;
    const set_active_data = props.setActiveData;
    const [current_index,set_current_index] = useState(0);
    const [no_of_page,set_no_of_page] = useState<any>([0]);
    

    const handleNext = ()=>{
        if(current_index + 1 > end-1){
            set_current_index(0);
            return;
        }
        set_current_index(current_index + 1);

    }
    const handlePrevious = () =>{
        if(current_index == 0) return;
        set_current_index(current_index - 1);

    }

    useEffect(()=>{
        if(data && data.length > 0){
            set_active_data(data.slice(0,no_per_page));
            end = Math.ceil(data.length/no_per_page);
            let arr:number[] = [];
            for(let i = 0;i<end;i++){
                arr.push(i);
            }
            set_no_of_page(arr);
        }
    },[data])

    useEffect(()=>{
        if(data && data.length > 0){
            const start = (current_index*no_per_page);
            const next = start+no_per_page; 
            set_active_data(data.slice(start,next));
        }
        
    },[current_index,data])


    return (
        <PageDiv>
            <div>
                <span onClick={handlePrevious}><LeftIcon /></span>
                <div>
                    {no_of_page && no_of_page.length > 0 ?
                    no_of_page.map((ePage:number) =>
                        <span key={ePage} onClick={()=>set_current_index(ePage)} className={ePage == current_index?'active':''}>{ePage+1}</span>
                    )
                    :''
                    }
                   
                </div>
                <span onClick={handleNext}><RightIcon/></span>  
            </div>
            

        </PageDiv>
    )
}
const MessageForm = styled.form`
    display: flex;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: center;
    & > label{
        display: flex;
        flex-direction: column;
        gap:10px;
    }
    & > label > span{
        font-size:18px;
        font-weight: bold;
        width:fit-content;
    }
    & > label > span::after{
        content:'*';
        color:red;
        display: inline-block;
        
    }
    & textarea{
        resize: vertical;
        outline:none;
        padding:10px;
        border-radius: 6px;
        
    }
    & >div{
        width:100%;
        text-align:center;
        margin-top:20px;
    }
`